
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
     class="position-absolute w-100 h-100" style="top: 0; left: 0; pointer-events: none">
  <defs>
<ng-container *ngFor="let line of flowLines; trackBy: trackFlowLine">
  <ng-container *ngIf="line && isValidLine(line)">
    <path
      [attr.id]="'flowPath' + line.x1 + '_' + line.y1 + '_' + line.x2 + '_' + line.y2"
      [attr.d]="getAnimatedPath(line)">
    </path>
  </ng-container>
</ng-container>

  </defs>

<ng-container *ngFor="let line of flowLines; trackBy: trackFlowLine">
  <use [attr.href]="'#flowPath' + line.x1 + '_' + line.y1 + '_' + line.x2 + '_' + line.y2"
       stroke="#afafaf"
       fill="transparent"
       stroke-width="2" />

  <circle r="4" [attr.fill]="line.colorScale" *ngIf="line.animated">
    <animateMotion dur="3s" repeatCount="indefinite"
                   [attr.keyPoints]="line.invert ? '1;0.55;0.45;0' : '0;0.45;0.55;1'"
                   keyTimes="0;0.45;0.55;1" calcMode="linear">
      <mpath [attr.xlink:href]="'#flowPath' + line.x1 + '_' + line.y1 + '_' + line.x2 + '_' + line.y2"></mpath>
    </animateMotion>
  </circle>
</ng-container>



</svg>
